import { axiosReq } from "utils";
import { ProfileActions } from "./ProfileReducer";
import { toast } from "sonner";

export const getUser = (getToken, signOut) => {
  return async (dispatch) => {
    const token = await getToken();

    try {
      dispatch(ProfileActions.getUserRequest());
      const response = await axiosReq({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/users/findMe`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      });
      dispatch(ProfileActions.getUserSuccess(response?.data));
    } catch (error) {
      if (error?.response?.status == 403) {
        if (!window.location.pathname?.includes("/certificate")) {
          signOut && signOut();
        }
      }

      dispatch(
        ProfileActions.getUserError(
          error.response?.data.message || error?.message
        )
      );
    }
    dispatch(clearStates());
  };
};

export const checkUser = (email, login) => async (dispatch) => {
  try {
    dispatch(ProfileActions.checkUserRequest());
    const response = await axiosReq({
      method: "get",
      url: `${process.env.REACT_APP_BACKEND_URL}/users/user`,
      withCredentials: true,
      params: { email },
    });

    dispatch(ProfileActions.checkUserSuccess(response?.data));
    await login();
  } catch (error) {
    dispatch(
      ProfileActions.checkUserErrors(
        error.response?.data.message || error?.message
      )
    );
  }
  dispatch(clearStates());
};
export const getIdentity = (getToken) => {
  return async (dispatch) => {
    const token = await getToken();

    try {
      dispatch(ProfileActions.getIdentityRequest());
      const response = await axiosReq({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/users/identity`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      });
      dispatch(ProfileActions.getIdentitySuccess(response?.data));
    } catch (error) {
      dispatch(
        ProfileActions.getIdentityError(
          error.response?.data.message || error?.message
        )
      );
    }
    dispatch(clearStates());
  };
};

export const editUser = (data, getToken) => {
  return async (dispatch) => {
    const token = await getToken();

    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      if (data[key]) {
        formData.append(key, data[key]);
      }
    });

    try {
      dispatch(ProfileActions.editUserRequest());
      const response = await axiosReq({
        method: "patch",
        url: `${process.env.REACT_APP_BACKEND_URL}/users`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: formData,
        withCredentials: true,
      });
      dispatch(getUser(getToken));
      dispatch(ProfileActions.editUserSuccess(response?.data));
    } catch (error) {
      dispatch(
        ProfileActions.editUserError(
          error.response?.data.message || error?.message
        )
      );
    }
    dispatch(clearStates());
  };
};

export const editIdentity = (data, getToken) => {
  return async (dispatch) => {
    const token = await getToken();

    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      if (data[key]) {
        formData.append(key, data[key]);
      }
    });

    try {
      dispatch(ProfileActions.editIdentityLoading());
      const response = await axiosReq({
        method: "patch",
        url: `${process.env.REACT_APP_BACKEND_URL}/users/identity`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: formData,
        withCredentials: true,
      });
      dispatch(getIdentity(getToken));
      dispatch(ProfileActions.editIdentitySuccess(response?.data));
    } catch (error) {
      dispatch(
        ProfileActions.editIdentityError(
          error.response?.data.message || error?.message
        )
      );
    }
    dispatch(clearStates());
  };
};

export const createIdentity = (data, getToken) => {
  return async (dispatch) => {
    const token = await getToken();

    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      if (data[key]) {
        formData.append(key, data[key]);
      }
    });

    try {
      dispatch(ProfileActions.createIdentityRequest());
      const response = await axiosReq({
        method: "post",
        url: `${process.env.REACT_APP_BACKEND_URL}/users/identity`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: formData,
        withCredentials: true,
      });
      dispatch(getIdentity(getToken));
      dispatch(ProfileActions.createIdentitySuccess(response?.data));
    } catch (error) {
      dispatch(
        ProfileActions.createIdentityError(
          error.response?.data.message || error?.message
        )
      );
    }
    dispatch(clearStates());
  };
};

export const getWalletInfo = (getToken) => {
  return async (dispatch) => {
    const token = await getToken();
    try {
      dispatch(ProfileActions.getWalletInfoRequest());
      const response = await axiosReq({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/transactions/walletInfo`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      });
      dispatch(ProfileActions.getWalletInfoSuccess(response?.data));
    } catch (error) {
      dispatch(
        ProfileActions.getWalletInfoError(
          error.response?.data.message || error?.message
        )
      );
    }
    dispatch(clearStates());
  };
};

export const getTransactions = (getToken, params) => {
  return async (dispatch) => {
    const token = await getToken();
    try {
      dispatch(ProfileActions.getTransactionsRequest());
      const response = await axiosReq({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/transactions/transactions`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
        withCredentials: true,
      });
      dispatch(ProfileActions.getTransactionsSuccess(response?.data));
    } catch (error) {
      dispatch(
        ProfileActions.getTransactionsError(
          error.response?.data.message || error?.message
        )
      );
    }
    dispatch(clearStates());
  };
};

export const getLiveChallenges = (getToken) => {
  return async (dispatch) => {
    const token = await getToken();
    try {
      dispatch(ProfileActions.getLiveChallengesRequest());
      const response = await axiosReq({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/challenge/getLiveChallenges`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      });
      dispatch(ProfileActions.getLiveChallengesSuccess(response?.data));
    } catch (error) {
      dispatch(
        ProfileActions.getLiveChallengesError(
          error.response?.data.message || error.message
        )
      );
    }
    dispatch(clearStates());
  };
};

export const withdraw = (data, getToken) => {
  return async (dispatch) => {
    const token = await getToken();
    try {
      dispatch(ProfileActions.withdrawRequest());
      const response = await axiosReq({
        method: "patch",
        url: `${process.env.REACT_APP_BACKEND_URL}/transactions/withdraw`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: { ...data },
        withCredentials: true,
      });
      dispatch(getWalletInfo(getToken));
      dispatch(getTransactions(getToken));
      dispatch(getLiveChallenges(getToken));
      dispatch(ProfileActions.withdrawSuccess(response?.data));
    } catch (error) {
      dispatch(
        ProfileActions.withdrawError(
          error.response?.data.message || error.message
        )
      );
    }
    dispatch(clearStates());
  };
};

//submit transaction
export const submitTransaction = (data, getToken) => {
  return async (dispatch) => {
    const token = await getToken();
    try {
      dispatch(ProfileActions.submitTransactionRequest());
      const response = await axiosReq({
        method: "patch",
        url: `${process.env.REACT_APP_BACKEND_URL}/transactions/transfer`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: { ...data },
        withCredentials: true,
      });
      dispatch(getWalletInfo(getToken));
      dispatch(getTransactions(getToken));
      dispatch(ProfileActions.submitTransactionSuccess(response?.data));
      toast.success("Transaction Successful");
    } catch (error) {
      toast.error(error.response?.data.message || error.message);
      dispatch(
        ProfileActions.submitTransactionError(
          error.response?.data.message || error.message
        )
      );
    }
    dispatch(clearStates());
  };
};

export const clearStates = () => {
  return (dispatch) => {
    setTimeout(() => {
      dispatch(ProfileActions.clearStates());
    }, 3000);
  };
};
